const $ = jQuery;

class VideoLightbox {
	constructor() {
		this.lightboxTiggers = document.querySelectorAll('.video-lightbox .video-embed__play');
		this.closeTriggers = document.querySelectorAll('.video-lightbox-modal__close');
	}

	init() {
		this.lightboxTiggers.forEach( trigger => {
            trigger.addEventListener( 'click', this.handlePlayClick.bind( this ) );
        })

		this.closeTriggers.forEach( trigger => {
            trigger.addEventListener( 'click', this.handleCloseClick.bind( this ) );
        })

        this.setVideoRatio();
	}

    resized() {
        this.setVideoRatio();
    }
    
    handlePlayClick( e ) {
        // Open lightbox.
        const id = e.currentTarget.getAttribute('data-lightbox-id');
        const lightbox = document.getElementById( id );
        const iframe = lightbox.querySelector('iframe');

        lightbox.classList.add('video-lightbox-modal--active');

        const lazySrc = iframe.getAttribute('lazy-src');
        if ( lazySrc ) {
            iframe.src = `${lazySrc}&autoplay=1&loop=1&wmode=transparent&rel=0`;
        }
    }

    handleCloseClick( e ) {
        const lightbox = e.currentTarget.closest( '.video-lightbox-modal' );
        const iframe = lightbox.querySelector('iframe');

        iframe.src = '';
        lightbox.classList.remove('video-lightbox-modal--active')
    }

    setVideoRatio() {
        // If the screen isn't tall enough for the video, we will adjust it.
        document.querySelectorAll('.video-lightbox-modal').forEach( modal => {
            const iframe = modal.querySelector('iframe')
            const width = iframe.offsetWidth;
            
            if ( width / (16/9) > window.innerHeight ) {
                const ratio = Math.round(window.innerHeight / width * 100);

                iframe.parentNode.setAttribute('style', `padding-top: ${ratio}%`)
            } else {
                iframe.parentNode.removeAttribute('style');
            }
        });
    }
}

export default new VideoLightbox;